import CreateTransactionContainer from './CreateTransaction.container'

export default CreateTransactionContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/CreateTransaction/index.js